<template>
    <viewFile v-bind:wpsUrl="jwpsUrl" v-bind:token="jtoken"/>
</template>
<script>
    import viewFile from './view'
    export default {
        data(){
            return{
                jwpsUrl:'',
                jtoken:''
          }
        },
        created() {
            this.jwpsUrl = sessionStorage.wpsUrl;
            this.jtoken = sessionStorage.token;
            console.log(sessionStorage.wpsUrl,'sessionStorage.wpsUrl')
        },
        // 通过组件渲染wps的 iframe 框架
        components: {
            viewFile
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/file/viewFile.vue